module.exports = __webpack_public_path__ + "img/portrait-amelie.7008cdb.jpg";